import React from "react";

import { Box, Text } from "@chakra-ui/react";

export const Title: React.FC = () => {
	return (
		<Box>
			<Text textStyle="body2" color="red.500">
				Vista Portfolio
			</Text>
			<Text textStyle="h4" fontFamily="heading" lineHeight={"1.75rem"}>
				Edificios técnicos
			</Text>
			<Text textStyle="h4" fontFamily="heading" lineHeight={"1.75rem"}>
				y dedicados al mantenimiento
			</Text>
		</Box>
	);
};
